__turbopack_context__.v({
  "alert": "index-module-scss-module__Z6yAOW__alert",
  "container": "index-module-scss-module__Z6yAOW__container",
});
